// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.contact-form-modal {
  background: white;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 30px;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.contact-form-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  line-height: 1;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-form-close:hover {
  color: #000;
}

.contact-form-modal h2 {
  margin: 0 0 20px 0;
  font-size: 24px;
  color: #333;
}

.contact-form-modal p {
  margin: 0 0 20px 0;
  color: #666;
  line-height: 1.5;
}

.contact-form-field {
  margin-bottom: 20px;
}

.contact-form-field label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.contact-form-field input,
.contact-form-field textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  box-sizing: border-box;
}

.contact-form-field input:focus,
.contact-form-field textarea:focus {
  outline: none;
  border-color: #666;
}

.contact-form-field textarea {
  resize: vertical;
  min-height: 100px;
}

.contact-form-error {
  background-color: #fee;
  color: #c33;
  padding: 10px 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
}

.contact-form-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.contact-form-button {
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.contact-form-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.contact-form-button-primary {
  background-color: #000;
  color: white;
}

.contact-form-button-primary:hover:not(:disabled) {
  background-color: #333;
}

.contact-form-button-secondary {
  background-color: #f5f5f5;
  color: #333;
}

.contact-form-button-secondary:hover:not(:disabled) {
  background-color: #e5e5e5;
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactForm/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".contact-form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.contact-form-modal {\n  background: white;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 30px;\n  position: relative;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.contact-form-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact-form-close:hover {\n  color: #000;\n}\n\n.contact-form-modal h2 {\n  margin: 0 0 20px 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.contact-form-modal p {\n  margin: 0 0 20px 0;\n  color: #666;\n  line-height: 1.5;\n}\n\n.contact-form-field {\n  margin-bottom: 20px;\n}\n\n.contact-form-field label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.contact-form-field input,\n.contact-form-field textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.contact-form-field input:focus,\n.contact-form-field textarea:focus {\n  outline: none;\n  border-color: #666;\n}\n\n.contact-form-field textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.contact-form-error {\n  background-color: #fee;\n  color: #c33;\n  padding: 10px 12px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.contact-form-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.contact-form-button {\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n}\n\n.contact-form-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.contact-form-button-primary {\n  background-color: #000;\n  color: white;\n}\n\n.contact-form-button-primary:hover:not(:disabled) {\n  background-color: #333;\n}\n\n.contact-form-button-secondary {\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n.contact-form-button-secondary:hover:not(:disabled) {\n  background-color: #e5e5e5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
